import type { VoicingFamily, VoicingFamilySelection } from '@/music/voicingFamilies';

// Joe Pass stays in the music model and saved records while its planner is
// paused. These lists describe what the app currently offers, not valid data.
export const AVAILABLE_VOICING_FAMILY_IDS = [
  'drop-2',
  'drop-3',
] as const satisfies readonly VoicingFamily[];
export const AVAILABLE_VOICING_FAMILY_SELECTION_IDS = [
  'drop-2',
  'drop-3',
  'drop-2-3',
] as const satisfies readonly VoicingFamilySelection[];

export function availableVoicingFamily(selection: VoicingFamilySelection): VoicingFamilySelection {
  return selection === 'joe-pass' ? 'drop-2' : selection;
}
